module.exports = __webpack_public_path__ + "static/media/leanin.375e199d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/finals/books/leanin.jpg
// module id = 297
// module chunks = 0